module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_9016.68c77697.png";